import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';

// List of cooking-related terms for the loader text
const loaderTexts = [
  '<Cooking>',
  '<Basting>',
  '<Roasting>',
  '<Steaming>',
  '<Sizzling>',
  '<Grilling>',
  '<Braai\'ing>',
  '<Marinating>',
  '<Seasoning>',
  '<Preparing>'
];

interface NavLinkInterceptorProps extends NavLinkProps {
  children: React.ReactNode;
}

const NavLinkInterceptor: React.FC<NavLinkInterceptorProps> = ({ children, to, ...rest }) => {
  const { setIsLoading, setLoaderText } = useLoading();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Don't intercept if it's the current page
    if (to === window.location.pathname) {
      return;
    }

    // Select a random loader text
    const randomIndex = Math.floor(Math.random() * loaderTexts.length);
    setLoaderText(loaderTexts[randomIndex]);
    
    // Show loader immediately
    setIsLoading(true);
  };

  return (
    <NavLink to={to} onClick={handleClick} {...rest}>
      {children}
    </NavLink>
  );
};

export default NavLinkInterceptor;